import logSxSCommandBarDatapoint from './logSxSCommandBarDatapoint';
import { AttachmentModel, ReferenceAttachmentModel } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { openInNewTab } from 'open-in-new-tab';
import { ControlIcons } from 'owa-control-icons';
import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { OpenInNewTabText } from 'owa-locstrings/lib/strings/openinnewtabtext.locstring.json';
import getProjection from 'owa-popout-v2/lib/utils/getProjection';
import { getOrCreateSxSStoreData, lazyTryCloseSxS } from 'owa-sxs-store';
import { PreviewPaneMode } from 'owa-sxsdata';
import { findTabIdBySxSId } from 'owa-tab-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function getOpenCloudyDocumentInNewTabButton(sxsId: string): FilterableMenuItem {
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    let openUrl: string;
    if (
        sxsStore.extendedViewState.isCloudy &&
        sxsStore.viewState.previewPane?.mode === PreviewPaneMode.Wac
    ) {
        if (sxsStore.extendedViewState.attachmentId) {
            // For cloudy attachments, always use openUrl from ReferenceAttachmentModel
            const attachmentModel: AttachmentModel = getAttachment(
                sxsStore.extendedViewState.attachmentId
            );
            if (attachmentModel) {
                openUrl = (attachmentModel as ReferenceAttachmentModel).openUrl;
            }
        }

        if (!openUrl && !!sxsStore.viewState.previewPane.jsApiInfo?.openUrl) {
            openUrl = sxsStore.viewState.previewPane.jsApiInfo.openUrl;
        }
    }

    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(OpenInNewTabText),
        [FilterableMenuItemArgs.icon]: ControlIcons.ReopenPages,
        [FilterableMenuItemArgs.onClick]: () => {
            const tabId = findTabIdBySxSId(sxsId);
            const projection = getProjection(tabId);
            openInNewTab(openUrl, projection?.window || window);
            if (isFeatureEnabled('doc-SxS-OpenInNewTab')) {
                lazyTryCloseSxS.importAndExecute('OpenInNewTab', sxsId);
            }
            logSxSCommandBarDatapoint('OpenInNewTab', sxsId, {
                customData: { isLink: !sxsStore.extendedViewState.attachmentId },
            });
        },
        [FilterableMenuItemArgs.shouldShow]: () => !!openUrl,
        [FilterableMenuItemArgs.ariaLabel]: loc(OpenInNewTabText),
    });
}
